import * as end from '../constants/api'
import { axiosInstance } from './axios-instance'

const TrackingServices = {
	handleTracking: ({ userId, payload }) => {
		return axiosInstance.post(end.tracking({ userId }), payload).then(res => res.data)
	}
}

export default TrackingServices
